import {
  DatePicker,
  Dropdown,
  Form,
  Input,
  Spin,
  Table,
  Tooltip,
  Checkbox,
} from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import CardLoading from "../../../components/CardLoading";
import BreadCrumb from "../../../layout/BreadCrumb";
import Search from "../../../components/Search";
import {
  fetchDashboard,
  fetchTransactions,
  fetchUsers,
} from "../../../features/fetch/fetchSlice";
import MaterialIcon from "material-icons-react";
import { downloadExcel } from "../../../features/global/globalSlice";
import {
  cashConverter,
  dateForHumans,
  disabledDate, 
  normalizeDateToLocal, 
} from "../../../utils";

const { RangePicker } = DatePicker;
export default function BankTable() {
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { transactionData, loading, transactionCount, dashboardData } =
    useSelector((state) => state.fetch);
  const { glbLoading } = useSelector((state) => state.global);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);

  const [searchInput, setsearchInput] = useState(null);

  const columns = [
    {
      title: "Orgnaization",
      dataIndex: "orgName",
      sorter: (a, b) => a.orgName.localeCompare(b.orgName),
    },

    {
      title: "OK Status",
      dataIndex: "ok",
      render: (item) => {
        return (
          <div
            className="text-[#FFF] inline-block rounded-[5px] px-2 py-1 w-auto"
            style={{
              backgroundColor: item ? "#28A745" : "#F44336",
            }}
          >
            {item ? "Yes" : "No"}
          </div>
        );
      },
      sorter: (a, b) => (a.ok === b.ok ? 0 : a.ok ? 1 : -1),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.amount - b.amount,
    },
   
    
    {
      title: "Available Balance",
      dataIndex: "availableBalance",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.availableBalance - b.availableBalance,
    },
    {
      title: "Reversal Indicator",
      dataIndex: "reversalIndicator",
      sorter: (a, b) => a.reversalIndicator.localeCompare(b.reversalIndicator),
      render: (item) => {
        return <div className="uppercase">{item}</div>;
      },
    },
    {
      title: "Debit/Credit",
      dataIndex: "debitCreditIndicator",
      sorter: (a, b) =>
        a.debitCreditIndicator.localeCompare(b.debitCreditIndicator),
    },
    {
      title: "Transaction Date",
      dataIndex: "transactionDate",
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
      sorter: (a, b) => a.transactionDate.localeCompare(b.transactionDate),
    },
    {
      title: "Value Date",
      dataIndex: "valueDate",
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
      sorter: (a, b) => a.valueDate.localeCompare(b.valueDate),
    },
    {
      title: "Account Number",
      dataIndex: "accountNumber",
      sorter: (a, b) => a.accountNumber.localeCompare(b.accountNumber),
    },

    {
      title: "CBS Reference",
      dataIndex: "cbsReference",
      sorter: (a, b) => a.cbsReference.localeCompare(b.cbsReference),
    },
    {
      title: "Customer Mobile",
      dataIndex: "customerMobile",
      sorter: (a, b) => a.customerMobile.localeCompare(b.customerMobile),
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      sorter: (a, b) => a.customerName.localeCompare(b.customerName),
    },

    {
      title: "Exchange Rate",
      dataIndex: "exchangeRate",
      sorter: (a, b) => a.exchangeRate - b.exchangeRate,
    },
    {
      title: "Transaction Code",
      dataIndex: "transactionCode",
      sorter: (a, b) => a.transactionCode.localeCompare(b.transactionCode),
    },
    {
      title: "Transaction Description",
      dataIndex: "transactionDescription",
      width: 200,
      sorter: (a, b) =>
        a.transactionDescription.localeCompare(b.transactionDescription),
    },
    {
      title: "Narration",
      dataIndex: "narration",
      width: 300,
      sorter: (a, b) => a.narration.localeCompare(b.narration),
      render: (text) => {
        if (!text) return "--";
        return (
          <Tooltip title={text} placement="topLeft">
            <div
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                wordBreak: "break-word",
                cursor: "pointer",
              }}
            >
              {text}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Transaction Status",
      dataIndex: "trnStatus",
      sorter: (a, b) => a.trnStatus.localeCompare(b.trnStatus),
    },
    {
      title: "Xref",
      dataIndex: "xref",
      sorter: (a, b) => a.xref.localeCompare(b.xref),
    },
  ];

  const [activeBtn, setActiveBtn] = useState(null);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchTransactions({
        url: "api/v1/payments/fetch-bank-trx",
        search: e.target.value == "" ? null : e.target.value,
        startDate: normalizeDateToLocal(startDate),
        endDate: normalizeDateToLocal(endDate),
      })
    );
  };

  const handleDownload = async (item) => {
    const res = await dispatch(
      downloadExcel({
        url: "api/v1/payments/downloadTransactionsBank",
        startDate: normalizeDateToLocal(startDate),
        endDate: normalizeDateToLocal(endDate),
        search: searchInput,
      })
    );
    if (res?.payload) {
      const blobData = res.payload.data;
      const headers = res.payload.headers;
      const contentType = headers["content-type"] || "application/octet-stream";
      const contentDisposition = headers["content-disposition"];
      let fileName = "bank";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }
      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      await toast.success(`${fileName} downloaded successfully`);
    } else {
      toast.error("Failed to download file");
    }
  };

  const onValuesChange = (changedValues) => {
    if (changedValues.hasOwnProperty("day")) {
      if (changedValues.day) {
        // Filter for today's transactions
        const startOfDay = dayjs().startOf("day");
        const endOfDay = dayjs().endOf("day");

        setStartDate(startOfDay.toDate());
        setEndDate(endOfDay.toDate());
        form.setFieldsValue({ range: [startOfDay, endOfDay] });

        dispatch(
          fetchTransactions({
            url: "api/v1/payments/fetch-bank-trx",
            startDate: normalizeDateToLocal(startOfDay.toDate()),
            endDate: normalizeDateToLocal(endOfDay.toDate()),
          })
        );
        setActiveBtn("");
      } else {
        // Reset filter when unchecked
        setStartDate(null);
        setEndDate(null);
        form.resetFields(["range"]);
        dispatch(
          fetchTransactions({
            url: "api/v1/payments/fetch-bank-trx",
            startDate: null,
            endDate: null,
          })
        );
      }
    }

    if (changedValues.hasOwnProperty("range") && changedValues.range) {
      const [start, end] = changedValues.range;
      setStartDate(start.toDate());
      setEndDate(end.toDate());

      form.setFieldsValue({ day: false });

      dispatch(
        fetchTransactions({
          url: "api/v1/payments/fetch-bank-trx",
          startDate: normalizeDateToLocal(start.toDate()),
          endDate: normalizeDateToLocal(end.toDate()),
        })
      );
      setActiveBtn("");
    }
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTransactionsData(page, size) {
    dispatch(
      fetchTransactions({
        url: "api/v1/payments/fetch-bank-trx",
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        startDate: normalizeDateToLocal(startDate),
        endDate: normalizeDateToLocal(endDate),
        search: searchInput,
        payOrgId: null,
      })
    );
  }

  useEffect(() => {
    fetchTransactionsData();
  }, []);
  const breadList = [
    {
      title: (
        <div className="flex items-center gap-[.25rem]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <g clipPath="url(#clip0_627_13942)">
              <path
                d="M13.7899 6.89067L7.75241 0.856289L7.34772 0.451602C7.25551 0.360003 7.13082 0.308594 7.00085 0.308594C6.87087 0.308594 6.74618 0.360003 6.65397 0.451602L0.211783 6.89067C0.117301 6.98478 0.0426296 7.09687 -0.00782254 7.22031C-0.0582747 7.34376 -0.0834854 7.47607 -0.0819665 7.60942C-0.0757165 8.15942 0.382096 8.59848 0.932096 8.59848H1.59616V13.6875H12.4055V8.59848H13.0837C13.3508 8.59848 13.6024 8.49379 13.7915 8.30473C13.8846 8.21193 13.9583 8.10159 14.0085 7.98009C14.0586 7.8586 14.0842 7.72836 14.0837 7.59692C14.0837 7.33129 13.979 7.07973 13.7899 6.89067ZM7.87585 12.5625H6.12585V9.37504H7.87585V12.5625ZM11.2805 7.47348V12.5625H8.87585V9.00004C8.87585 8.65473 8.59616 8.37504 8.25085 8.37504H5.75085C5.40553 8.37504 5.12585 8.65473 5.12585 9.00004V12.5625H2.72116V7.47348H1.22116L7.00241 1.69691L7.36335 2.05785L12.7821 7.47348H11.2805Z"
                fill="black"
                fillOpacity="0.45"
              />
            </g>
            <defs>
              <clipPath id="clip0_627_13942">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>Home</span>
        </div>
      ),
      href: "/#/home",
    },
    {
      title: <div className="text-lighGold text-[16px]">Bank</div>,
    },
  ];

  const statusKeys = Object?.keys(
    dashboardData?.bankTransactions?.[0] || {}
  )?.filter((key) => key !== "name" && key !== "colors");
  if (loading && !searchInput && !startDate && !endDate) return <CardLoading />;
  return (
    <div className="w-full h-full overflow-y-scroll">
      <div className="justify-between items-center white_card">
        <BreadCrumb
          breadList={breadList}
          header={"Bank"}
          info={"Here’s an overview of your bank"}
        />
      </div>

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <div className="flex items-center mt-[1.25rem] justify-between ">
            <div className="flex justify-start items-center ">
              <h3 className="heading_4 ">Bank</h3>
            </div>
            <div className="justify-end flex">
              <Form
                layout="vertical"
                ref={formRef}
                name="control-ref"
                onValuesChange={onValuesChange}
                className=""
                style={{
                  maxWidth: "100%",
                }}
                form={form}
              >
                <div className="flex items-center lg:flex-row flex-col gap-5">
                  <Form.Item name="day" valuePropName="checked">
                    <Checkbox>Today</Checkbox>
                  </Form.Item>

                  <Form.Item name="range">
                    <RangePicker disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Form>
            </div>
          </div>

          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="w-[16.8125rem]">
              <Search
                searchInput={searchInput}
                handleSearch={handleSearch}
                text={"Search ..."}
              />
            </div>
            <div className="flex justify-end item-center">
              {transactionData && transactionData?.length > 0 && (
                <div className="flex justify-end item-center">
                  {glbLoading ? (
                    <Spin className="sms-spin" />
                  ) : (
                    <Tooltip placement="top" title={"Download Excel"}>
                      <button
                        onClick={handleDownload}
                        className="flex items-center"
                      >
                        <MaterialIcon
                          size={45}
                          color="#00B050"
                          icon="article"
                        />
                        <span>Export to excel</span>
                      </button>
                    </Tooltip>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="mb-5">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.trnId}
                columns={columns}
                dataSource={transactionData}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: transactionCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchTransactionsData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
